module.exports = __webpack_public_path__ + "img/NINJA-01.jpg";